import { GenericAbortSignal } from "axios";
import { AutoCompleteHierarchicalModel, AutoCompleteHierarchicalSuggestions, UnitAutoCompleteHierarchicalModel } from "components/MprcAutoCompleteHierarchical/AutoCompleteHierarchicalModel";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";
import React from "react";
import { IUnitAutoCompleteProps, UnitAutoCompleteHierarchicalComponent } from "views/foundation/unit/components/UnitAutoCompleteHierarchicalComponent";

////////////////////////////////////////////////////////////////////////////

interface IProps extends IUnitAutoCompleteProps {
    showRoot?: boolean;
    unitTypeId?: string;
    unitTypeName?: string;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete hierarquico de unidades administrativa
 * @param props
 */
export const UnitAutoCompleteHierarchical: React.FC<IProps> = (props) => {

    const {
        unitTypeId,
        showDescendantOption,
        showRoot = false,
        required = false,
        disabled = false,
        selectedMode = 'free',
        onError
    } = props;

    const api = useCoreApi();

    /// Carrega a lista de sugestões
    const getSuggestions = (parentId: string | null, trySelectionHistory: boolean, searchText: string, pageNumber: number, pageSize: number, signal: GenericAbortSignal | undefined): Promise<AutoCompleteHierarchicalSuggestions<AutoCompleteHierarchicalModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteHierarchicalSuggestions<UnitAutoCompleteHierarchicalModel>>((resolve) => {
            api.v1.suggestions.unitHierarchical({
                unitTypeId: unitTypeId ?? null,
                parentId: parentId,
                trySelectionHistory: trySelectionHistory,
                allowIncludeDescendants: showDescendantOption ?? false,
                showRoot,
                ignoreAllowAssociates: false, // (REMOVIDO pela NP-3753: a checagem será feita no próprio UnitAutoCompleteHierarchicalComponent)
                searchText: searchText,
                pageNumber: pageNumber,
                pageSize: pageSize,
            }, { signal })
                .then(result => {
                    resolve({
                        items: result.data.items as UnitAutoCompleteHierarchicalModel[],
                        totalRows: result.data.totalRows
                    });
                })
                .catch(e => {
                    if (!isCanceledError(e)) {
                        resolve({ items: [], totalRows: 0 });
                        onError(e);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <UnitAutoCompleteHierarchicalComponent
            {...props}
            required={required}
            disabled={disabled}
            selectedMode={selectedMode}
            showUnitTypeName={unitTypeId == undefined}
            onGetSuggestions={getSuggestions}
        />
    );
};
